import React from 'react';
import { Divider } from '@mui/material';
import { Routes } from 'routing';
import { matchPath, useLocation } from 'react-router-dom';
import TabContainer from 'components/nav/TabContainer';

import BookingPricing from './BookingPricing';
import SalesPricing from './SalesPricing';
import { useTranslation } from 'services/localization';

const Pricing = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const { productId } =
		matchPath<{ productId: string }>(location.pathname, {
			path: Routes.CATALOG_PRODUCT,
		})?.params ?? {};

	if (!productId) return null;

	return (
		<>
			<Divider sx={{ mb: 2 }} />
			<TabContainer
				basePath={Routes.ProductPageTab(productId, 'pricing')}
				tabs={[
					{
						path: 'bookings',
						label: t('product.bookings', 'Bookings'),
						component: BookingPricing,
					},
					{
						path: 'sales',
						label: t('product.sales', 'Sales'),
						component: SalesPricing,
					},
				]}
				tabStyle="secondary"
				defaultTab="bookings"
			/>
		</>
	);
};

export default Pricing;
